import {
  CATALOG_ITEM_STATUSES,
  CONFIDENCE,
  PROPOSAL_STATUSES,
  REVIEWER_STATUSES,
  RUN_STATUSES,
  SETUP_STATUSES,
  TEMPLATE_RUN_STATUSES,
  VALIDATION_STATUSES,
} from '@services/fmdc';
import { DISPLAY_STUCK } from './format';

// Status → theme token, in one place, so every pill, dot and chip in the feature agrees and all
// three themes work for free. There is no `success` token in the theme; `positive` is the one.

// In-flight stages pulse, the StatusBadge treatment for a running job.
export const RUN_STATUS_TOKENS = {
  [RUN_STATUSES.PENDING]: 'primaryCtaButton',
  [RUN_STATUSES.INVENTORY]: 'primaryCtaButton',
  [RUN_STATUSES.HEADERS]: 'primaryCtaButton',
  [RUN_STATUSES.CLASSIFY]: 'primaryCtaButton',
  [RUN_STATUSES.NORMALIZE]: 'primaryCtaButton',
  [RUN_STATUSES.VALIDATE]: 'primaryCtaButton',
  [RUN_STATUSES.REVIEW]: 'warning',
  [RUN_STATUSES.LOADABLE]: 'positive',
  [RUN_STATUSES.ERROR]: 'negative',
  [DISPLAY_STUCK]: 'negative',
};

export const RUN_PULSING_STATUSES = [
  RUN_STATUSES.PENDING,
  RUN_STATUSES.INVENTORY,
  RUN_STATUSES.HEADERS,
  RUN_STATUSES.CLASSIFY,
  RUN_STATUSES.NORMALIZE,
  RUN_STATUSES.VALIDATE,
];

export const SETUP_STATUS_TOKENS = {
  [SETUP_STATUSES.QUEUED]: 'secondaryText',
  [SETUP_STATUSES.RUNNING]: 'primaryCtaButton',
  [SETUP_STATUSES.SUCCEEDED]: 'positive',
  [SETUP_STATUSES.FAILED]: 'negative',
};

export const TEMPLATE_RUN_TOKENS = {
  [TEMPLATE_RUN_STATUSES.RUNNING]: 'primaryCtaButton',
  [TEMPLATE_RUN_STATUSES.COMPLETE]: 'positive',
  [TEMPLATE_RUN_STATUSES.ERROR]: 'negative',
};

export const CONFIDENCE_TOKENS = {
  [CONFIDENCE.HIGH]: 'positive',
  [CONFIDENCE.MEDIUM]: 'warning',
  [CONFIDENCE.LOW]: 'negative',
};

export const VALIDATION_TOKENS = {
  [VALIDATION_STATUSES.PASS]: 'positive',
  [VALIDATION_STATUSES.WARNING]: 'warning',
  [VALIDATION_STATUSES.FAIL]: 'negative',
  [VALIDATION_STATUSES.NOT_CHECKED]: 'secondaryText',
};

// The Chip tone (good | warn | bad | neutral) the same statuses take where a chip is used instead
// of a dot.
export const VALIDATION_TONES = {
  [VALIDATION_STATUSES.PASS]: 'good',
  [VALIDATION_STATUSES.WARNING]: 'warn',
  [VALIDATION_STATUSES.FAIL]: 'bad',
  [VALIDATION_STATUSES.NOT_CHECKED]: 'neutral',
};

export const REVIEWER_STATUS_TOKENS = {
  [REVIEWER_STATUSES.PENDING]: 'secondaryText',
  [REVIEWER_STATUSES.MIXED]: 'warning',
  [REVIEWER_STATUSES.APPROVED]: 'positive',
  [REVIEWER_STATUSES.REJECTED]: 'negative',
};

export const PROPOSAL_STATUS_TOKENS = {
  [PROPOSAL_STATUSES.PENDING]: 'secondaryText',
  [PROPOSAL_STATUSES.APPROVED]: 'positive',
  [PROPOSAL_STATUSES.REJECTED]: 'negative',
};

export const CATALOG_STATUS_TOKENS = {
  [CATALOG_ITEM_STATUSES.ACTIVE]: 'positive',
  [CATALOG_ITEM_STATUSES.PROPOSED]: 'secondaryText',
  [CATALOG_ITEM_STATUSES.RETIRED]: 'negative',
};

const FALLBACK_TOKEN = 'secondaryText';

export const tokenFor = (map, value) => map[value] || FALLBACK_TOKEN;
